import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, debounceTime, distinctUntilChanged, first } from 'rxjs';

import { ProjectEntityListActions } from '../../store/project-entity-list/project-entity-list.actions';
import { selectOnlyMine, selectSearchPhrase } from '../../store/project-entity-list/project-entity-list.selectors';

@Component({
  selector: 'app-project-list-filter',
  templateUrl: './project-list-filter.component.html',
  styleUrls: ['./project-list-filter.component.scss'],
  standalone: false
})
export class ProjectListFilterComponent implements OnInit {
  searchPhrase$: Observable<string>;
  onlyMine$: Observable<boolean>;

  emptyFilterValues = { searchPhrase: '', onlyMine: true };

  constructor(
    private fb: FormBuilder,
    private store: Store
  ) {
    this.store
      .select(selectSearchPhrase)
      .pipe(first())
      .subscribe(searchPhrase => {
        this.filterForm.patchValue({ searchPhrase: searchPhrase });
      });
    this.store
      .select(selectOnlyMine)
      .pipe(first())
      .subscribe(onlyMine => {
        this.filterForm.patchValue({ onlyMine: onlyMine });
      });
  }

  filterForm = this.fb.group({
    searchPhrase: [this.emptyFilterValues.searchPhrase],
    onlyMine: [this.emptyFilterValues.onlyMine]
  });

  isEmpty() {
    return this.filterForm.value.searchPhrase == '';
  }

  ngOnInit() {
    this.filterForm.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
      this.store.dispatch(ProjectEntityListActions.change_filter(this.filterForm.getRawValue()));
    });
  }

  search() {
    this.store.dispatch(ProjectEntityListActions.search());
  }
}
